import { Button, ButtonProps } from '@mui/material';
import { PropsWithChildren } from 'react';

import TrailingArrowIcon from '../../assets/icons/TrailingArrow';

interface PaymentTypeButtonProps extends ButtonProps {}

const PaymentTypeButton = ({
  children,
  ...props
}: PropsWithChildren<PaymentTypeButtonProps>) => {
  return (
    <Button
      disableRipple
      sx={{
        background: 'none',
        boxShadow: 0,
        border: 1,
        borderRadius: 2,
        borderColor: '#E3E5EE',
        color: 'black',
        display: 'flex',
        fontSize: 18,
        fontWeight: 700,
        justifyContent: 'space-between',
        p: 2,
        textTransform: 'none',
        width: 1,

        '&:hover': {
          background: 'none',
          boxShadow: 0,
        },
      }}
      endIcon={<TrailingArrowIcon />}
      {...props}
    >
      {children}
    </Button>
  );
};

export default PaymentTypeButton;
